import { EventType } from "globals/types/models.ts";
import { useAppDispatch, useAppSelector } from "config/store";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import SingleEventModal from "components/modals/SingleEventModal.tsx";
import PublicEventCard from "components/layouts/card/PublicEventCard.tsx";
import { authActions } from "config/store/modules/auth.ts";
import Button from "components/atom/button/Button.tsx";

function FeaturedEventsPage() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const eventById: { [key: number]: EventType } = useAppSelector(state => state.search.eventById);
  const featuredEventIds: number[] = useAppSelector(state => state.search.featuredEventIds);

  const [selectedEvent, setSelectedEvent] = useState<EventType | null>(null);


  const featuredEvents = useMemo(() => {
    return featuredEventIds.map(id => eventById[id]);
  }, [featuredEventIds, eventById]);


  const onEventClick = useCallback((eventId: number) => {
    const event = eventById[eventId];
    setSelectedEvent(event);
    //log click
    dispatch(authActions.statCollectionEventByUuid(event.uuid, "click", "featured_list"));
  }, [dispatch, eventById]);

  return (
    <div className="container mx-auto py-12 md:py-24 pb-32 md:pb-40">
      <h1 className="font-bold">
        {t("featured.title")}
      </h1>
      {featuredEvents.length === 0 && (
        <div className="pt-12">
          <p className=" text-gray-400">
            {t("featured.noEvents")}
          </p>
          <Button
            to="/map"
            className="mt-12"
          >
            {t("homePage.hero.accessMapButton")}
          </Button>
        </div>
      )}
      {featuredEvents.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 pt-6 md:mt-12">
          {featuredEvents.map(event => (
            <PublicEventCard
              key={event.id}
              event={event}
              onClick={() => onEventClick(event.id)}
            />
          ))}
        </div>
      )}

      <SingleEventModal
        onClose={() => {
          setSelectedEvent(null);
        }}
        event={selectedEvent} />
    </div>
  );
}

export default FeaturedEventsPage;
